import { render, staticRenderFns } from "./PantallaAlertas.vue?vue&type=template&id=edd5ba6a&"
import script from "./PantallaAlertas.vue?vue&type=script&lang=ts&"
export * from "./PantallaAlertas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports